import React from 'react';
import ESIInclude from '@JohnLewisPartnership/jl-esi-components';
import { ThemeProvider } from 'jl-design-system/contexts/Theme';
import HeaderWrapper from '../components/header-wrapper/HeaderWrapper';
import EnvVarsFeaturesContext from './EnvVarsFeaturesContext';
import { UserContextProvider } from '../scaffold/UserContext';

class HeaderApp extends React.Component {
  constructor(props) {
    super();
    const {
      envVars = {},
      features = {},
      categories = {},
      headerClientConfigQueryParameters = {},
      query = {},
      notificationBannerFolder = '',
    } = props.initialState;
    this.envVars = envVars;
    this.features = features;
    this.categories = categories;
    this.headerClientConfigQueryParameters = headerClientConfigQueryParameters;
    this.query = query;
    this.notificationBannerFolder = notificationBannerFolder;
  }

  render() {
    return (
      <div>
        <UserContextProvider>
          <EnvVarsFeaturesContext.Provider
            value={{
              envVars: this.envVars,
              features: this.features,
              categories: this.categories,
              headerClientConfigQueryParameters: this
                .headerClientConfigQueryParameters,
              query: this.query,
            }}
          >
            <>
              <ThemeProvider>
                <HeaderWrapper features={this.features} />
              </ThemeProvider>
              {this.notificationBannerFolder ? (
                <ESIInclude
                  id="header-notification-banner"
                  src={`/${this.envVars.bannerPath}/${this.notificationBannerFolder}/index.html`}
                  data-testid="header-notification-banner"
                />
              ) : (
                ''
              )}
            </>
          </EnvVarsFeaturesContext.Provider>
        </UserContextProvider>
      </div>
    );
  }
}

HeaderApp.displayName = 'HeaderApp';

export default HeaderApp;
